
import MdContent from 'components/md-content'
import SaveDoc from '../save-doc.vue'
export default {
  components: {MdContent, SaveDoc},
  props: {
    info: {type: Object, default: undefined},
    loading: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
  },
  emits: ['save'],
  computed: {
    title() {
      return this.info?.title
    },

    summary() {
      return this.info?.summary
    },
  }
}
